var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},_vm._l((_vm.openProjects),function(item){return _c('open-project',{directives:[{name:"show",rawName:"v-show",value:(item.projectId===_vm.activeProjectId),expression:"item.projectId===activeProjectId"}],key:item.projectId,ref:"openProjects",refInFor:true,attrs:{"project-id":item.projectId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }